import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mb-4 text-body-1"
};
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import ClientMatterSearch from '@/components/ClientMatterSearch.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'ChangeMatterDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    selectedCount: {
      type: Number,
      required: true
    },
    matterForm: {
      type: Object,
      required: true
    },
    itemLabel: {
      type: String,
      default: 'fixed fee'
    },
    itemLabelPlural: {
      type: String,
      default: 'fixed fees'
    }
  },
  emits: ['update:modelValue', 'confirm', 'cancel', 'matterChange'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // Store
    const meStore = useMeStore();
    const {
      me
    } = storeToRefs(meStore);

    // Computed
    const showDialog = computed({
      get: () => props.modelValue,
      set: value => emit('update:modelValue', value)
    });

    // Methods
    const handleCancel = () => {
      showDialog.value = false;
      emit('cancel');
    };
    const handleConfirm = () => {
      emit('confirm');
    };
    const handleMatterChange = () => {
      emit('matterChange');
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showDialog.value = $event),
        "max-width": "600px",
        persistent: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "text-h5 pa-4"
          }, {
            default: _withCtx(() => [_createTextVNode(" Change " + _toDisplayString(_unref(me)?.terms?.Matter || 'Matter'), 1)]),
            _: 1
          }), _createVNode(_component_v_card_text, {
            class: "pa-4"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, " You are moving " + _toDisplayString(__props.selectedCount) + " " + _toDisplayString(__props.selectedCount === 1 ? __props.itemLabel : __props.itemLabelPlural) + ". They will be updated to the new " + _toDisplayString(_unref(me)?.terms?.matter || 'matter') + ". ", 1), _createVNode(ClientMatterSearch, {
              cm: __props.matterForm,
              "query-filter": {},
              horizontal: true,
              "hide-details": false,
              "client-only": false,
              "show-add-client-matter": false,
              terms: {
                Matter: _unref(me)?.terms?.Matter || 'Matter'
              },
              onMatterChange: handleMatterChange
            }, null, 8, ["cm", "terms"])]),
            _: 1
          }), _createVNode(_component_v_card_actions, {
            class: "pa-4"
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              onClick: _withModifiers(handleCancel, ["stop"])
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" Cancel ", -1)]))]),
              _: 1
            }), _createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
              variant: "flat",
              color: "primary",
              disabled: !__props.matterForm.matter?.id,
              onClick: _withModifiers(handleConfirm, ["stop"]),
              "data-cy": "confirm-change-matter"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" Confirm Change ", -1)]))]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};